import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { usePayrollModuleAvailability } from 'modules/marketplace/hooks/usePayrollModuleAvailability'

import { ButtonSelector } from './ButtonSelector'
import { UpsellModal } from './UpsellModal'
import { upsellableIntegrations } from './UpsellModal/upsellableIntegrations'

interface ItemData {
  integration: ItemIntegrationFragment
}

export const InstallWorkflow = ({ integration }: ItemData) => {
  const upsellableIntegration = upsellableIntegrations[integration.datoId]
  const [upsellModalVisible, setUpsellModalVisible] = useState(false)

  const { shouldShowPayrollUpsell } = usePayrollModuleAvailability(integration)

  // Show modal if it's a regular upsellable integration OR if it's a Payroll integration that needs upsell
  const showUpsellModal = upsellableIntegration || shouldShowPayrollUpsell

  return (
    <Box>
      <ButtonSelector
        upsellableIntegration={upsellableIntegration}
        integration={integration}
        setUpsellModalVisible={setUpsellModalVisible}
      />
      {showUpsellModal && (
        <UpsellModal
          integration={integration}
          featureId={upsellableIntegration?.id}
          upsellModalVisible={upsellModalVisible}
          setUpsellModalVisible={setUpsellModalVisible}
        />
      )}
    </Box>
  )
}
